import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        formDisable: false,
        form: {
            models: [],  //绑定的模块或菜单ids
            model: {
                id: null,
                name: null,
                code: null,
                sort: 0,
                description: null,
                status: false,
                type: 2,
                source: null,
            }
        },
    },
    getters: {
        ['PermissionResourceFormGetModels'](state) {
            return state.form.models;
        },
        ['PermissionResourceFormGetFormModel'](state) {
            return state.form.model;
        }
    },
    mutations: {
        ['PermissionResourceFormSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['PermissionResourceFormSetFormModel'](state, model) {
            state.form.model = model;
        },
        ['PermissionResourceFormSetFormDisable'](state, disable) {
            state.formDisable = disable;
        },
        ['PermissionResourceFormSetModels'](state, models) {
            state.form.models = models;
        },
        ['PermissionResourceFormSetFormModelToNull'](state) {
            state.form.model = {
                id: null,
                name: null,
                code: null,
                sort: 0,
                description: null,
                status: false,
                type: 2,
            }
        },
    },
    actions: {
        async addForm({commit}, model) {
            commit('PermissionResourceFormSetLoading', true);
            try {
                let result = await OrganizationServer.permission.add(model);
                commit('PermissionResourceFormSetLoading', false);
                if (result.data.code === '200') {
                    return result.data.data.id;
                } else {
                    return null;
                }
            } catch (e) {
                commit('PermissionResourceFormSetLoading', false);
                throw e;
            }
        },
        async updateForm({commit}, model) {
            commit('PermissionResourceFormSetLoading', true);
            try {
                let result = await OrganizationServer.permission.update(model.id, model);
                commit('PermissionResourceFormSetLoading', false);
                if (result.data.code === '200') {
                    return result.data.data.id;
                } else {
                    return null;
                }
            } catch (e) {
                commit('PermissionResourceFormSetLoading', false);
                throw e;
            }
        },
        async queryFormModel({commit}, id) {
            commit('PermissionResourceFormSetLoading', true);
            try {
                let result = await OrganizationServer.permission.findById(id);
                if (result.data.code === '200') {
                    commit('PermissionResourceFormSetFormModel', result.data.data);
                }
            } catch (e) {
                throw e;
            } finally {
                commit('PermissionResourceFormSetLoading', false);
            }
        }
    }
}
